import { SET_USER, REMOVE_USER } from "./Types";
const originalState = {
  username: "",
  name: "",
  phone: "",
  role: "staff",
  token: null
};
export default function user(
  defaultState = originalState,
  action
) {
  switch (action.type) {
    case SET_USER:
      return action.payload;
    case REMOVE_USER:
      return originalState;
    default:
      return defaultState;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/AuthReducers.js